export enum SchemaField {
  InputText = 'InputText',
  InputNumber = 'InputNumber',
  InputPassword = 'InputPassword',
  InputCurrency = 'InputCurrency',
  InputCheckbox = 'InputCheckbox',
  InputSwitch = 'InputSwitch',
  InputSelect = 'InputSelect',
  InputFile = 'InputFile',
  InputDateTime = 'InputDateTime',
  InputMask = 'InputMask',
  InputAutoComplete = 'InputAutoComplete',
  InputMultipleSelect = 'InputMultipleSelect',
  InputDate = 'InputDate',
  InputPhoneNumber = 'InputPhoneNumber',
  InputMultipleAutoComplete = 'InputMultipleAutoComplete',
  InputTabs = 'InputTabs',
  InputTextEditor = 'InputTextEditor',
  InputTimePicker = 'InputTimePicker'
}

export enum SchemaInputType {
  file = 'file',
  checkbox = 'checkbox',
  text = 'text',
  url = 'url',
  email = 'email',
  textarea = 'textarea',
  texteditor = 'texteditor',
  number = 'number',
  password = 'password',
}
